import { render, staticRenderFns } from "./hqglLogisticsBaseClass.vue?vue&type=template&id=71cda5d2&scoped=true&"
import script from "./hqglLogisticsBaseClass.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsBaseClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cda5d2",
  null
  
)

export default component.exports